var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"select-dropdown"}},[_c('b-dropdown',{attrs:{"slot":this.position,"text":_vm.$t(_vm.value),"variant":_vm.theme},slot:this.position},_vm._l((_vm.values),function(item){return _c('b-dropdown-item',{key:item.id,on:{"click":function($event){_vm.setSelected(item)}}},[_vm._v(_vm._s(_vm.$t(item)))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cdf5fb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/SelectDropdown.vue
// module id = 603
// module chunks = 1